<template>
    <div class="data-center">
        <p class="alert alert-warning">提示：本页面提供的数据仅供商户作为调整经营策略参考，不作为结款与验证的准确依据</p>
        <div class="data-container">
            <h2>历史数据概览及数据趋势</h2>
            <div class="form-horizontal">
                <form class="form-group">
                    <label class="col-item control-label">选择时间：</label>
                    <div class="col-item">
                        <v-datepicker :message="start" v-model="start" :options="timeOption"></v-datepicker>
                    </div>
                    <div class="col-item margin-top">
                        ~
                    </div>
                    <div class="col-item">
                        <v-datepicker :options="timeOption" :message="end" v-model="end"></v-datepicker>
                    </div>
                    <button class="btn btn-primary" :disabled="buttonDisable" v-on:click="getDataTableList">查询</button>
                    <span style="color:red;">{{intro}}</span>
                </form>
            </div>
            <table class="table table-striped  table-hover">
                <thead :class="[textLeft, isDecrease? asc: desc]">
                    <th :class="{'active': order==='name'}" v-on:click="orderBy('name')">
                        <span>项目名称</span>
                    </th>
                    <th class="width-s" :class="{'active': order==='sales'}" v-on:click="orderBy('sales')">
                        <span>购买券</span>
                    </th>
                    <th class="width-s" :class="{'active': order==='buy_rate'}" v-on:click="orderBy('buy_rate')">
                        <span>购买率</span>
                    </th>
                    <th class="width-s" :class="{'active': order==='consumption'}" v-on:click="orderBy('consumption')">
                        <span>验证券</span>
                    </th>
                    <th class="width-s" :class="{'active': order==='consumption_rate'}" v-on:click="orderBy('consumption_rate')">
                        <span>验证率</span>
                    </th>
                    <th class="width-s" :class="{'active': order==='refund'}" v-on:click="orderBy('refund')">
                        <span>退款券</span>
                    </th>
                    <th class="width-s" :class="{'active': order==='refund_rate'}" v-on:click="orderBy('refund_rate')">
                        <span>退款率</span>
                    </th>
                    <th class="width-s" :class="{'active': order==='pv'}" v-on:click="orderBy('pv')">
                        <span>浏览量</span>
                    </th>
                    <th class="width-s" :class="{'active': order==='uv'}" v-on:click="orderBy('uv')">
                        <span>访客量</span>
                    </th>
                </thead>
                <tbody>
                    <tr v-for="item in datalist">
                        <td>{{item.name}}</td>
                        <td>{{item.sales}}</td>
                        <td>{{item.buyRate | floatToPercent}}</td>
                        <td>{{item.consumption}}</td>
                        <td>{{item.consumptionRate | floatToPercent}}</td>
                        <td>{{item.refund}}</td>
                        <td>{{item.refundRate | floatToPercent}}</td>
                        <td>{{item.pv}}</td>
                        <td>{{item.uv}}</td>
                    </tr>
                </tbody>

            </table>
            <p v-if="noData" class="alert alert-warning">该时间段内无数据。。</p>
        </div>
    </div>
</template>
<style lang="postcss">
.data-center {
    padding: 20px;
    .alert {
        padding: 10px;
        margin-bottom: 20px;
        border: 1px solid transparent;
        border-radius: 0;
        font-size: 14px;
    }
    .alert-warning {
        background-color: #fff7e5;
        border-color: #ffd98c;
        color: #666;
    }
    .data-container {
        border: 1px solid #ccc;
        border-radius: 4px;
        margin-top: 30px;
        padding: 20px;
        .col-item {
            position: relative;
            min-height: 1px;
            padding-left: 15px;
            padding-right: 15px;
            display: inline-block;
            float: left;
        }
        .table-striped {
            thead.text-left {
                background-color: #f9f9f9;
                th {
                    text-align: left;
                    cursor: pointer;
                }
                th.width-s {
                    width: 80px;
                }
                th span::after {
                    display: inline-block;
                    width: 14px;
                    color: #29b3a3;
                    content: "";
                }
                th:hover span:after {
                    content: "▼";
                }
            }
            thead.asc th.active span::after {
                content: "▲";
            }

            thead.desc th.active span::after {
                content: "▼";
            }
        }
    }
}
</style>
<script>
import { getDataTable } from 'api/dataCenter.js';
import { formatDate as formdate } from 'helpers/formatDate.js';
export default {
    data() {
        return {
            datalist: [],
            page: 1,
            count: 10,
            rank: 'desc',
            start: this.getFormateDate(new Date((new Date().valueOf()-24*60*60*1000))),
            end: this.getFormateDate(new Date((new Date().valueOf()-24*60*60*1000))),
            searchFlag: false,
            order: '',
            isDecrease: false,
            asc: 'asc',
            desc: 'desc',
            textLeft: "text-left",
            noData: true,
            intro: '',
            buttonDisable: false,
            timeOption: {
                //maxDate: new Date((new Date().valueOf() - 24 * 60 * 60 * 1000)),
                //minDate: new Date((new Date().valueOf() - 90 * 24 * 60 * 60 * 1000)),
                onChange: (date) => {
                    this.$nextTick(
                        I => {
                            if (this.start && this.end) {
                                if (this.end > this.getFormateDate(new Date((new Date().valueOf() - 24 * 60 * 60 * 1000)))) {
                                    this.intro = "结束时间应选在昨天之前";
                                }
                                else if (this.start > this.end) {
                                    this.intro = "结束时间应大于开始时间";
                                }
                                else if (this.getFormateDate(new Date((new Date(this.end).valueOf() - 90 * 24 * 60 * 60 * 1000))) > this.start) {
                                    this.intro = "开始与结束时间间隔需小于90天";
                                }
                                else if (this.start < this.getFormateDate(new Date((new Date().valueOf() - 90 * 24 * 60 * 60 * 1000))) || this.end < this.getFormateDate(new Date((new Date().valueOf() - 90 * 24 * 60 * 60 * 1000)))) {
                                    this.intro = "请选择最近3个月内数据";
                                }
                                else {
                                    this.intro = "";
                                    this.buttonDisable = false;
                                }
                                if (this.intro) {
                                    this.buttonDisable = true;
                                }
                            }
                        }
                    )
                }
            },
        }
    },
    created: function () {
        this.getDataTableList();
    },
    methods: {
        getDataTableList: function() {
            getDataTable({
                page: this.page,
                count: this.count,
                rank: this.rank,
                start: this.start,
                end: this.end,
                order: this.order
            }).then((response) => {
                if (response.status === 0 && response.data) {
                    this.datalist = response.data.list;
                    this.noData = !this.datalist.length;
                }
            }).catch((error) => {
                this.alert(error);
            })
        },
        alert(message) {
            this.$alert({
                title: '提示',
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        getFormateDate(date) {
            return this.formdate(date, 'yyyy-MM-dd');
        },
        formdate(time) {
            var date = new Date(time);
            return formdate(date, 'yyyy-MM-dd')
        },
        orderBy(filter) {
            this.isDecrease = !this.isDecrease;
            this.order = filter;
            this.rank= this.isDecrease? 'asc': 'desc';
            this.getDataTableList();
            
        },
        check() {
            if(this.start&& this.end) {
                if(new Date(this.end)>this.getFormateDate(new Date((new Date().valueOf()-24*60*60*1000)))) {
                    this.intro = "结束时间应选在昨天之前";
                }
                if(new Date(this.start) > new Date(this.end)) {
                    this.intro = "结束时间应大于开始时间";
                }

            }
        }
    },
}
</script>



// WEBPACK FOOTER //
// programData.vue?1ccd2e4a